module.exports = "../fonts/Futura-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./@fonts/futura/Futura-Bold.woff2
// module id = 515
// module chunks = 7